export default {
  path: 'migration',
  name: 'migrationList',
  component: () => import('@/pages/system/migration/MigrationList'),
  meta: { title: '表迁移记录' }
}
